import React, { createContext, useState, useEffect } from 'react';
import i18n from '../i18n';

export const authContext = createContext({});

const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({ loading: true, data: null });
  // we will use loading later
  
    const setAuthData = (data) => {   
      setAuth({data: data});
    };
    

    useEffect(() => {
      setAuth({ loading: false, data: JSON.parse(window.sessionStorage.getItem('authIke'))});
    }, []);

    useEffect(() => {
      window.sessionStorage.setItem('authIke', JSON.stringify(auth.data));
    }, [auth]);

    useEffect(()=>{
    //seteamo el idioma por si refresca el navegador
    if(!auth.loading && auth.data){
      i18n.changeLanguage(auth.data.language) 
    }
  },[auth])
  
    return (
      <authContext.Provider value={{ auth, setAuthData }}>
        {children}
      </authContext.Provider>
    );
  };
  
  export default AuthProvider;